import React, { useState, useEffect, useContext, useRef } from 'react';

import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSectionCombination from 'components/layout_and_quote_builder/LayoutNavSectionCombination.jsx';

const LayoutNavSectionCombinationListList = ({ list, count, setSelectedList }) => {
  const [totalScore, setTotalScore] = useState(0)
  const [totalScoreList, setTotalScoreList] = useState({})
  const [numTotals, setNumTotals] = useState( {} )
  const [numOfDrawingsInSet, setNumOfDrawingsInSet] = useState( {} )

  const handleClick = () => {
    setSelectedList( list )
  }

  const showNavSectionCombination = ( result, index ) => {
    return <LayoutNavSectionCombination
      index = {index}
      diecutting_result={result.diecutting_result}
      count={count}
      layout_dimension={result.material_layout_dimension}
      setTotalScoreList={setTotalScoreList}
      setNumTotals={setNumTotals}
      setNumOfDrawingsInSet={setNumOfDrawingsInSet}
    />
  }

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_total_diecutting = numTotals[i]
      list[i].num_total_printing   = numTotals[i] * list[i].diecutting_result.printing_result.num_x  * list[i].diecutting_result.printing_result.num_y
    }
  }, [numTotals] )


  useEffect( () => {
    setTotalScore( () => Object.values(totalScoreList).reduce((a, b) => a + b, 0)  )
  }, [totalScoreList])

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_of_drawings_in_set = numOfDrawingsInSet[i]
    }
  }, [numOfDrawingsInSet] )

  return (
    <div className={styles.combinations_grid_item_cont} key={name} data-score={totalScore} onClick={handleClick}>
      <div> { window.isAdminShowDebug && <>{totalScore} <br /></> } {list.map((result, index) => (
        <React.Fragment key={index}>
          {showNavSectionCombination(result, index)}
        </React.Fragment>
      ))} </div>
    </div>
  )
}

export default LayoutNavSectionCombinationListList;
